import React from 'react';
import './blog-post.css';
import './blog-slides.css';
import attendees1 from './pictures/picnicAttendees.JPG'
import attendees2 from './pictures/picnicAttendees2.JPG'
import attendees3 from './pictures/picnicAttendees3.JPG'
import socialMedia from './pictures/socialMediaCommitteePicnic.JPG'


const SpringKickoffPicnic = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Spring MM1: Spring Kickoff Picnic</h2>
                    <p className="site-post-meta">April 9, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you for joining us for our first Member Meeting of the quarter at our Spring Kickoff Picnic! We had an amazing time with summer tunes, lots of snacks and root beer floats, and games like Apples to Apples, Uno, and Exploding Kittens! 
                    <br></br>
                    <br></br>
                    We hope you guys had an amazing time and start to your spring quarter.
                    <br></br>
                    <br></br>
                    </p>
                    <img src={attendees3} alt="Attendees posing for a picture at event."/>
                    <img src={attendees2} alt="Attendees talking and eating on picnic blankets."/>
                    <img src={attendees1} alt="Attendees talking and eating on picnic blankets."/>
                    <img src={socialMedia} alt="Social Media Committee posing for a picture"/>

                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default SpringKickoffPicnic;
